"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ThreadWorker", {
    enumerable: true,
    get: function() {
        return ThreadWorker;
    }
});
const _createFilteredStreamTransform = require("./createFilteredStreamTransform.js");
const _readline = require("readline");
const _stdioStreamMarkers = require("./stdioStreamMarkers.js");
const _events = require("events");
const _stream = require("stream");
const _TaskInfo = require("./TaskInfo.js");
const _worker_threads = require("worker_threads");
const _crypto = /*#__PURE__*/ _interop_require_default(require("crypto"));
const _v8 = /*#__PURE__*/ _interop_require_default(require("v8"));
function _check_private_redeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) {
        throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
}
function _class_apply_descriptor_get(receiver, descriptor) {
    if (descriptor.get) {
        return descriptor.get.call(receiver);
    }
    return descriptor.value;
}
function _class_apply_descriptor_set(receiver, descriptor, value) {
    if (descriptor.set) {
        descriptor.set.call(receiver, value);
    } else {
        if (!descriptor.writable) {
            throw new TypeError("attempted to set read only private field");
        }
        descriptor.value = value;
    }
}
function _class_extract_field_descriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to " + action + " private field on non-instance");
    }
    return privateMap.get(receiver);
}
function _class_private_field_get(receiver, privateMap) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "get");
    return _class_apply_descriptor_get(receiver, descriptor);
}
function _class_private_field_init(obj, privateMap, value) {
    _check_private_redeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function _class_private_field_set(receiver, privateMap, value) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "set");
    _class_apply_descriptor_set(receiver, descriptor, value);
    return value;
}
function _class_private_method_get(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return fn;
}
function _class_private_method_init(obj, privateSet) {
    _check_private_redeclaration(obj, privateSet);
    privateSet.add(obj);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const workerFreeEvent = "free";
const maxOldSpaceSizeBytes = _v8.default.getHeapStatistics().total_available_size;
var _taskInfo = /*#__PURE__*/ new WeakMap(), _stdoutInfo = /*#__PURE__*/ new WeakMap(), _stderrInfo = /*#__PURE__*/ new WeakMap(), // @ts-ignore TS2564
_worker = /*#__PURE__*/ new WeakMap(), _createNewWorker = /*#__PURE__*/ new WeakSet(), _ready = /*#__PURE__*/ new WeakSet(), _captureWorkerStdioStreams = /*#__PURE__*/ new WeakSet(), _handleAbort = /*#__PURE__*/ new WeakSet();
class ThreadWorker extends _events.EventEmitter {
    start(work, abortSignal) {
        this.status = "busy";
        const { task, resolve, reject, cleanup, setup } = work;
        abortSignal?.addEventListener("abort", _class_private_method_get(this, _handleAbort, handleAbort));
        const id = _crypto.default.randomBytes(32).toString("hex");
        _class_private_field_set(this, _taskInfo, new _TaskInfo.TaskInfo({
            id,
            weight: work.weight,
            cleanup,
            resolve,
            reject,
            worker: this,
            setup,
            abortSignal
        }));
        // Create a pair of promises that are only resolved when a specific task end marker is detected
        // in the worker's stdout/stderr streams.
        _class_private_field_get(this, _stdoutInfo).promise = new Promise((onResolve)=>{
            _class_private_field_get(this, _stdoutInfo).resolve = onResolve;
        });
        _class_private_field_get(this, _stderrInfo).promise = new Promise((onResolve)=>{
            _class_private_field_get(this, _stderrInfo).resolve = onResolve;
        });
        _class_private_field_get(this, _worker).postMessage({
            type: "start",
            task: {
                ...task,
                weight: work.weight
            },
            id
        });
    }
    get weight() {
        return _class_private_field_get(this, _taskInfo)?.weight ?? 1;
    }
    get stdout() {
        return _class_private_field_get(this, _stdoutInfo).stream;
    }
    get stderr() {
        return _class_private_field_get(this, _stderrInfo).stream;
    }
    get resourceLimits() {
        return _class_private_field_get(this, _worker).resourceLimits;
    }
    get threadId() {
        return _class_private_field_get(this, _worker).threadId;
    }
    terminate() {
        _class_private_field_get(this, _worker).removeAllListeners();
        _class_private_field_get(this, _worker).terminate();
        _class_private_field_get(this, _worker).unref();
    }
    restart() {
        this.restarts++;
        this.status = "busy";
        _class_private_field_get(this, _worker).terminate();
        _class_private_method_get(this, _createNewWorker, createNewWorker).call(this);
    }
    async checkMemoryUsage() {
        _class_private_field_get(this, _worker).postMessage({
            type: "check-memory-usage"
        });
    }
    postMessage(value, transferList) {
        _class_private_field_get(this, _worker).postMessage(value, transferList);
    }
    constructor(script, options){
        super(), _class_private_method_init(this, _createNewWorker), _class_private_method_init(this, _ready), _class_private_method_init(this, _captureWorkerStdioStreams), _class_private_method_init(this, _handleAbort), _define_property(this, "script", void 0), _define_property(this, "options", void 0), _class_private_field_init(this, _taskInfo, {
            writable: true,
            value: void 0
        }), _class_private_field_init(this, _stdoutInfo, {
            writable: true,
            value: void 0
        }), _class_private_field_init(this, _stderrInfo, {
            writable: true,
            value: void 0
        }), _class_private_field_init(this, _worker, {
            writable: true,
            value: void 0
        }), _define_property(this, "status", void 0), _define_property(this, "restarts", void 0), _define_property(this, "maxWorkerMemoryUsage", void 0), this.script = script, this.options = options, _class_private_field_set(this, _stdoutInfo, {
            stream: new _stream.Readable(),
            promise: Promise.resolve(),
            resolve: ()=>{}
        }), _class_private_field_set(this, _stderrInfo, {
            stream: new _stream.Readable(),
            promise: Promise.resolve(),
            resolve: ()=>{}
        }), this.status = "busy", this.restarts = 0, this.maxWorkerMemoryUsage = 0;
        if (!options.workerIdleMemoryLimitPercentage) {
            options.workerIdleMemoryLimitPercentage = 80;
        }
        _class_private_method_get(this, _createNewWorker, createNewWorker).call(this);
    }
}
function createNewWorker() {
    const { workerOptions } = this.options;
    const script = this.script;
    const worker = new _worker_threads.Worker(script, {
        ...workerOptions,
        stdout: true,
        stderr: true
    });
    _class_private_method_get(this, _captureWorkerStdioStreams, captureWorkerStdioStreams).call(this, worker);
    const filteredStdout = worker.stdout.pipe((0, _createFilteredStreamTransform.createFilteredStreamTransform)());
    const filteredStderr = worker.stderr.pipe((0, _createFilteredStreamTransform.createFilteredStreamTransform)());
    let capturedStdoutResolve = ()=>{};
    const capturedStdoutPromise = new Promise((resolve)=>{
        capturedStdoutResolve = resolve;
        resolve();
    });
    let capturedStderrResolve = ()=>{};
    const capturedStderrPromise = new Promise((resolve)=>{
        capturedStderrResolve = resolve;
        resolve();
    });
    const msgHandler = (data)=>{
        if (data.type === "status") {
            // In case of success: Call the callback that was passed to `runTask`,
            // remove the `TaskInfo` associated with the Worker, and mark it as free
            // again.
            Promise.all([
                _class_private_field_get(this, _stdoutInfo).promise,
                _class_private_field_get(this, _stderrInfo).promise
            ]).then(()=>{
                const { err, results } = data;
                if (_class_private_field_get(this, _taskInfo)) {
                    _class_private_field_get(this, _taskInfo).abortSignal?.removeEventListener("abort", _class_private_method_get(this, _handleAbort, handleAbort));
                    _class_private_field_get(this, _taskInfo).done(err, results);
                }
                this.checkMemoryUsage();
            });
        } else if (data.type === "report-memory-usage") {
            this.maxWorkerMemoryUsage = Math.max(this.maxWorkerMemoryUsage, data.memoryUsage);
            const workerMaxOldGenSizeMb = _class_private_field_get(this, _worker).resourceLimits?.maxOldGenerationSizeMb;
            const limit = this.options.workerIdleMemoryLimit ?? (workerMaxOldGenSizeMb ? workerMaxOldGenSizeMb * 1024 * 1024 : maxOldSpaceSizeBytes) * this.options.workerIdleMemoryLimitPercentage / 100;
            if (limit && data.memoryUsage > limit) {
                this.restart();
            } else {
                _class_private_method_get(this, _ready, ready).call(this);
            }
        } else {
            this.emit("message", data);
        }
    };
    worker.on("message", msgHandler);
    const errHandler = (err)=>{
        // We likely have a worker that has crashed - many instances of this is due to out-of-memory errors, we need to fail fast!
        _class_private_field_get(this, _stdoutInfo).resolve();
        _class_private_field_get(this, _stderrInfo).resolve();
        // In case of an uncaught exception: Call the callback that was passed to
        // `runTask` with the error, otherwise, just emit an "error" event (which will crash the process if not handled)
        if (_class_private_field_get(this, _taskInfo)) {
            _class_private_field_get(this, _taskInfo).abortSignal?.removeEventListener("abort", _class_private_method_get(this, _handleAbort, handleAbort));
            _class_private_field_get(this, _taskInfo).done(err, null);
        } else {
            this.emit("error", err);
        }
    };
    // The 'error' event is emitted if the worker thread throws an uncaught exception. In that case, the worker is terminated.
    worker.on("error", errHandler);
    // Assign the new worker to private properties
    _class_private_field_set(this, _worker, worker);
    _class_private_field_set(this, _stdoutInfo, {
        stream: filteredStdout,
        promise: capturedStdoutPromise,
        resolve: capturedStdoutResolve
    });
    _class_private_field_set(this, _stderrInfo, {
        stream: filteredStderr,
        promise: capturedStderrPromise,
        resolve: capturedStderrResolve
    });
    _class_private_method_get(this, _ready, ready).call(this);
}
function ready() {
    let weight = 1;
    if (_class_private_field_get(this, _taskInfo)) {
        weight = _class_private_field_get(this, _taskInfo).weight;
        _class_private_field_set(this, _taskInfo, undefined);
    }
    this.status = "free";
    this.emit(workerFreeEvent, {
        weight
    });
}
function captureWorkerStdioStreams(worker) {
    const stdout = worker.stdout;
    const stdoutInterface = (0, _readline.createInterface)({
        input: stdout,
        crlfDelay: Infinity
    });
    const stderr = worker.stderr;
    const stderrInterface = (0, _readline.createInterface)({
        input: stderr,
        crlfDelay: Infinity
    });
    // by the time we have a "line" event, we expect there to have been a this.#taskInfo
    const lineHandlerFactory = (outputType)=>{
        let lines = [];
        let resolve;
        return (line)=>{
            if (!_class_private_field_get(this, _taskInfo)) {
                // Somehow this lineHandler function is called AFTER the worker has been freed.
                // This can happen if there are stray setTimeout(), etc. with callbacks that outputs some messages in stdout/stderr
                // In this case, we will ignore the output
                return;
            }
            if (line.includes((0, _stdioStreamMarkers.startMarker)(_class_private_field_get(this, _taskInfo).id))) {
                lines = [];
                if (outputType === "stdout") {
                    resolve = _class_private_field_get(this, _stdoutInfo).resolve;
                } else {
                    resolve = _class_private_field_get(this, _stderrInfo).resolve;
                }
            } else if (line.includes((0, _stdioStreamMarkers.endMarker)(_class_private_field_get(this, _taskInfo).id))) {
                resolve();
            } else {
                lines.push(line);
            }
        };
    };
    const stdoutLineHandler = lineHandlerFactory("stdout");
    const stderrLineHandler = lineHandlerFactory("stderr");
    stdoutInterface.on("line", stdoutLineHandler);
    stderrInterface.on("line", stderrLineHandler);
}
function handleAbort() {
    if (_class_private_field_get(this, _worker)) {
        _class_private_field_get(this, _worker).postMessage({
            type: "abort"
        });
    }
}
